import React from 'react';
import './RadioButton.css';

const isEnabled = (enable) => {
  let isInputEnabled;
  switch (enable) {
    case true:
      isInputEnabled = '';
      break;
    case false:
      isInputEnabled = 'disabled';
      break;
    default:
      isInputEnabled = ''
  }
  return isInputEnabled;
}

const RadioButton = ({name, value, checkBoxDescripcion, callFunction, isChecked, onChangeCheck, radioId, enable, Checked}) => {
  return(
    <div className="customCheck">
      <label htmlFor={radioId}>
        <input
          type="radio"
          id={radioId}
          name={name}
          value={value}
          onClick={callFunction}
          onChange={onChangeCheck} 
          defaultChecked={isChecked}
          checked={Checked}
          disabled={isEnabled(enable)}
        />
        <span className="icon" />
        <p>{checkBoxDescripcion}</p>
      </label>
    </div>
  );
};
export default RadioButton;